// Kept out of theme.ts so color lookups don't load @mui/material (~260 ms per node test file).
export const assetCategoryColors = {
  equity: '#175242',
  globalEquity: '#C7BCA1',
  alternatives: '#F19E70',
  fixedIncome: '#A98EB1',
  cash: '#D79F32',
  multiAssetStrategy: '#C7BCA1',
};
